export default __webpack_public_path__ + "static/media/gamer_2.f2a0a2bf.png";